<template>
    <nav class="navbar navbar-expand-lg navbar-expand-md navbar-light bg-light w-100">
        <div class="container-fluid">
            <div class="nav-item me-sm-2 me-md-5 botonNav">
                <button
                    class="btn btn-info"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasNavbar"
                    aria-controls="offcanvasNavbar"
                >
                    <i class="bi bi-list iconoBarra"></i>
                </button>
            </div>
            <div v-show="mostrarRetorno" class="nav-item">
                <router-link 
                    v-if="$route.name == 'DetalleOperacion'"
                    :to="{ 
                        name: 'ListaPrincipal', 
                        params: { estatus: $route.params.estatus } 
                    }"
                >
                    <img src="../../../../public/icons/arrow-left.svg" id="iconNav" class="me-2">
                    Regresar a la lista
                </router-link>
                <router-link 
                    v-else-if="$route.name != 'DetalleOperacion'"
                    :to="{ 
                        name: 'ListaPrincipal', 
                        params: { estatus: 2 }
                    }"
                >
                    <img src="../../../../public/icons/arrow-left.svg" id="iconNav" class="me-2">
                    Regresar a la lista
                </router-link>
            </div>
            <button class="navbar-toggler bg-info rounded-pill text-center foto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                <div id="fotoUsuarioM"> 
                    <i class="bi bi-person iconoUsuario textoBlanco"></i>
                </div>
            </button>
            <div class="collapse navbar-collapse" id="navbarNavDropdown">
                <ul class="navbar-nav ms-auto dropdown-menu-end texto">
                    <li class="nav-item dropdown text-end">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            {{ $filters.CapitalizeFilter(nombreUsuario) }}
                        </a>
                        <ul class="dropdown-menu text-center" aria-labelledby="navbarDropdownMenuLink">
                            <li><a class="dropdown-item" href="#" @click="cerrarSesion">Cerrar Sesión</a></li>
                        </ul>
                    </li>
                    <li id="fotoUsuario" class="ms-2 bg-info text-center rounded-pill foto">
                        <div class="mt-1">
                            <i class="bi bi-person mt-2 textoBlanco"></i>
                        </div> 
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'NavegacionSuperior',

    props: {
        mostrarRetorno: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            usuario: {}
        }
    },

    computed: {
        nombreUsuario() {
            return this.obtenerPrimerNombre() + " " + this.usuario.apellidoPaterno
        }  
    },

    mounted() {
        this.validarSesion()
    },

    methods: {
        obtenerMensajeError(error) {
            if(String(error).includes("401")) {
                return 'Error de autenticación, por favor ingresa tus credenciales'
            }
            if(error == 'Error: Network Error') {
                return 'Error de conexión'
            }
            return error
        },

        async validarSesion() {
        await this.axios
            .post("Usuario/ValidarSesion")
            .then((response) => {
                this.respuesta = response.data
                if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                    this.obtenerUsuarioSesion()
                }
            })
            .catch((error) => {
                this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: this.obtenerMensajeError(error)});
            })
        },

        async obtenerUsuarioSesion() {
        await this.axios
            .post("Usuario/ObtenerUsuarioSesion")
            .then((response) => {
                this.respuesta = response.data
                if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                    this.usuario = this.respuesta.resultado
                }
                else {this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje})}
            })
            .catch((error) => {
                this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error == 'Error: Network Error' ? 'Error de conexión' : error});
            })
        },

        obtenerPrimerNombre() {
            var nombres
            if (String(this.usuario.nombre).includes(" ")) {
                nombres = this.usuario.nombre.split(" ")
                return nombres[0]
            }
            return this.usuario.nombre
        },

        async cerrarSesion() {
            await this.axios
            .post("Usuario/Logout")
            .catch((error) => {
                this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error == 'Error: Network Error' ? 'Error de conexión' : error});
            })
        }
    }
});
</script>

<style scoped>
    #iconNav {
        width: 15%;
    }
    
    #linkNav {
        font-size: 15px;
        color: #FFA000;
    }

    #fotoUsuarioM {
        margin-top: -2px;
        margin-left: -8px;
    }

    .iconoBarra {
        font-size: 20px;
    }

    .iconoUsuario {
        font-size: 30px;
    }

    .texto {
        font-weight: 400;
        font-style: normal;
        line-height: 16px;
        color: #302D74;
    }

    .textoBlanco {
        color: snow;
    }

    .foto {
        width: 40px;
        height: 40px;
        font-size: 30px;
    }

    @media (min-width: 992px) {
        .botonNav {
            display: none;
        }
    }

    @media (max-width: 992px) {
        .botonNav {
            display: block;
        }
    }

    @media (min-width: 767px) {
        #fotoUsuario {
            display: block;
        }
    }

    @media (max-width: 767px) {
        #fotoUsuario {
            display: none;
        }
    }
</style>